<template>
  <b-button-group>
    <b-button
      v-for="(opt, index) in sriOptions"
      :key="index"
      @click="pressed(opt.value)"
      size="sm"
      :variant="checkboxSelected.includes(opt.value) ? 'primary' : 'outline-primary'"
      >{{ opt.text }}</b-button
    >
  </b-button-group>
</template>

<script>
export default {
  props: ['sriOptions', 'value'],

  computed: {
    checkboxSelected: {
      get: function () {
        if (this.value.min === null || this.value.max === null) {
          return []
        } else {
          let i = this.value.min
          var temp = []
          for (i; i <= this.value.max; i++) {
            temp.push(i)
          }
          return temp
        }
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.$emit('input', { min: null, max: null })
        } else {
          this.$emit('input', { min: Math.min(...newValue), max: Math.max(...newValue) })
        }
      },
    },
  },

  methods: {
    pressed(index) {
      let justRemoved
      let justAdded
      if (this.checkboxSelected.includes(index)) {
        justRemoved = index
      } else {
        justAdded = index
      }

      if (this.checkboxSelected.length === 0 || (justRemoved !== undefined && this.checkboxSelected.length < 3)) {
        if (justAdded != null) {
          this.checkboxSelected.push(justAdded)
        }
        this.checkboxSelected = this.checkboxSelected.filter((el) => el !== justRemoved)
        return
      }

      let min = Math.min(...this.checkboxSelected)
      let max = Math.max(...this.checkboxSelected)

      if (justAdded === undefined) {
        //Is a removed item
        if (max - justRemoved < justRemoved - min) {
          if (justRemoved === max) {
            max = justRemoved - 1
          } else {
            max = justRemoved
          }
        } else {
          if (justRemoved === min) {
            min = justRemoved + 1
          } else {
            min = justRemoved
          }
        }
      } else {
        if (justAdded > max) {
          max = justAdded
        } else {
          min = justAdded
        }
      }
      const result = []
      for (let i = min; i <= max; i++) {
        result.push(i)
      }
      this.checkboxSelected = result
    },
  },
}
</script>

<style lang="scss" scoped>
.myCBGroup label:hover {
  box-shadow: 0 0 0 0.2rem rgba(234, 99, 62, 0.5);
  color: #ea633e;
  background-color: transparent;
}

.btn-group {
  width: 100%;
}

.active {
  background-color: red !important;
}
</style>
